import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useWhistleblowingCases } from 'contexts/whistleblowing-cases'
import { sendAppSignal } from 'hooks/app-signal'
import { size } from 'utilities/object'
import { Wrapper, Item } from './s'
import { Value, Label } from 'components/statistics-group/s'
import Badge from 'components/badge'
import { Plain } from 'components/button'

const WhistleblowingCasesStatistics = ({ namespace }) => {
    const {
        statistics = {},
        filter,
        fetching
    } = useWhistleblowingCases()

    if(!size(statistics)) {
        return null
    }

    const {
        unacknowledged = 0,
        open = 0
    } = statistics ?? {}

    const setFilters = (filters = []) => {
        sendAppSignal(`filter.${namespace}.set`, {
            filters: [
                {
                    name: 'statuses',
                    value: filters
                }
            ]
        })
    }

    const hasOnlyTheseFilters = (filters = []) => (
        filter?.statuses?.length === filters.length &&
        filters.every(status => filter?.statuses?.includes(status))
    )

    const unacknowledgedStatuses = ['new', 'seen']
    const openStatuses = ['acknowledged']

    return (
        <Wrapper>
            {('unacknowledged' in statistics) && (
                <Item as={!unacknowledged ? 'div' : 'label'}>
                    <Badge number={unacknowledged} />
                    <Label className="compact">
                        <FormattedMessage
                            id="incidents_statistics_label_unacknowledged"
                            defaultMessage="{count, plural, =0 {unacknowledged} =1 {unacknowledged} other {unacknowledged}}"
                            values={{ count: unacknowledged }} />
                    </Label>
                    <Plain
                        className="constructive small"
                        disabled={fetching || hasOnlyTheseFilters(unacknowledgedStatuses) || !unacknowledged}
                        onClick={() => setFilters(unacknowledgedStatuses)}>
                        <FormattedMessage
                            id="action_view"
                            defaultMessage="View" />
                    </Plain>
                </Item>
            )}
            {('open' in statistics) && (
                <Item as={!open ? 'div' : 'label'}>
                    <Value>{open}</Value>
                    <Label className="compact">
                        <FormattedMessage
                            id="incidents_statistics_label_open"
                            defaultMessage="{count, plural, =0 {open} =1 {open} other {open}}"
                            values={{ count: open }} />
                    </Label>
                    <Plain
                        className="constructive small"
                        disabled={fetching || hasOnlyTheseFilters(openStatuses) || !open}
                        onClick={() => setFilters(openStatuses)}>
                        <FormattedMessage
                            id="action_view"
                            defaultMessage="View" />
                    </Plain>
                </Item>
            )}
        </Wrapper>
    )
}

export default WhistleblowingCasesStatistics
